import { generateNomenApi, generateNomenOptions } from '@feature/nomenclature';

const wosIndexApi = generateNomenApi(`/nomen/wos-index`);

export const wosIndexOptions = generateNomenOptions('wos-index', wosIndexApi);
